import { InvoiceItemBase } from '../../invoicing/abstract/invoice-item-base.model';

export class PurchaseInvoiceItem extends InvoiceItemBase {

    static override CLASS_NAME: string = 'PurchaseInvoiceItem';

}
